'use client';

import { useEffect } from 'react';

export default function Page() {
  useEffect(() => {
    const redirect_uri = window.location.origin + '/callback/hubspot';
    window.location.href = `https://app.hubspot.com/oauth/authorize?client_id=ca3f2d2a-8fe2-4fd4-92cf-f6ff6d24837e&redirect_uri=${encodeURIComponent(
      redirect_uri
    )}&scope=crm.objects.contacts.read%20account-info.security.read`;
  }, []);

  return null;
}
